var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Core / Download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PMVP---Bank",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payments_07",
    transform: "translate(-432.000000, -425.000000)",
    fill: "#0046AA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Core-/-Download",
    transform: "translate(426.000000, 419.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,24 C25.553,24 26,24.447 26,25 C26,25.553 25.553,26 25,26 L25,26 L7,26 C6.447,26 6,25.553 6,25 C6,24.447 6.447,24 7,24 L7,24 Z M15.9997,6.0002 C16.5527,6.0002 16.9997,6.4472 16.9997,7.0002 L16.9997,7.0002 L16.9997,19.1722 L21.1387,15.0322 C21.5297,14.6412 22.1627,14.6412 22.5537,15.0322 C22.9437,15.4232 22.9437,16.0562 22.5537,16.4462 L22.5537,16.4462 L17.5857,21.4142 C17.2107,21.7892 16.7017,22.0002 16.1717,22.0002 L16.1717,22.0002 L15.8277,22.0002 C15.2977,22.0002 14.7887,21.7892 14.4137,21.4142 L14.4137,21.4142 L9.4467,16.4462 C9.0567,16.0562 9.0567,15.4232 9.4467,15.0322 C9.8367,14.6412 10.4707,14.6412 10.8617,15.0322 L10.8617,15.0322 L14.9997,19.1722 L14.9997,7.0002 C14.9997,6.4472 15.4477,6.0002 15.9997,6.0002 Z",
    id: "Download"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDl);
export default __webpack_public_path__ + "static/media/icon-dl.187bb738.svg";
export { ForwardRef as ReactComponent };